(function() {
    'use strict';

a3_cabin_reports.directive('groundInfo',groundInfo);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name groundInfo
   * @restrict EA
   * @description
   *   Implementation of groundInfo
   *
   *   Initialize the ground information (Contacts,Hotels)
   * @attr {String} station The name of the station to get the ground information.
   * @example
   *   Usage:
   *   <div groundInfo stations="ATH,LHR"></div>
   * @ngInject
   */    
function groundInfo(AirportContactFactory,AirportHotelFactory) {

         /**
          * Calculates distinct HotelTypes (used for filtering results)
          * @memberof AirportHotelCtrl
          * @param {array} All the airport Hotels (object which containts Hotels property)
          * @return {array} The distinct HotelTypes as an array of strings
         */
        function findDistinctHotelTypes(items){
            var unique = {};
            var distinct = [];
            for( var i in items ){
                if( items[i].Name && typeof(unique[items[i].Name]) == "undefined"){
                    distinct.push(items[i].Name);
                }
                unique[items[i].Name] = 0;
            }
            return distinct;
        }

        /**
          * Used to properly display some Hotel Types, eg nulls
          * @memberof AirportHotelCtrl
          * @param {string} The Hotel type to examine and "fix"
          * @return {string} The "fixed" string for the given Hotel type (maybe the same as the input value if no fix is needed)
          */
        function printHotelType(HotelType){
            if (!HotelType || HotelType == ''){
                console.log(HotelType);
                HotelType = '-no Hotel type-';
            }
                
            return HotelType;
        }
    
          /**
          * Calculates distinct ContactTypes (used for filtering results)
          * @memberof AirportContactCtrl
          * @param {array} All the airport contacts (object which containts Contacts property)
          * @return {array} The distinct ContactTypes as an array of strings
          */
        function findDistinctContactTypes(items){
            var unique = {};
            var distinct = [];
            for( var i in items ){
                if(items[i].ContactType &&  typeof(unique[items[i].ContactType]) == "undefined"){
                    distinct.push(items[i].ContactType);
                }
                unique[items[i].ContactType] = 0;
            }
            return distinct;
        }
        
         /**
          * Used to properly display some Contact Types, eg nulls
          * @memberof AirportContactCtrl
          * @param {string} The contact type to examine and "fix"
          * @return {string} The "fixed" string for the given contact type (maybe the same as the input value if no fix is needed)
          */
        function printContactType(contactType){
            if (!contactType || contactType == '')
                return '-no contact type-';
            return contactType;
        }
    
	
		return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/groundInfo.tpl.html',
			scope : true,
            link: function ($scope, element, attrs) {
                var stations = attrs.stations? attrs.stations.split(",") : [];
                $scope.stationsInfo = []
                $scope.filterHotelType = '';
                $scope.filterContactType = '';
       
                //scope methods
                $scope.printHotelType = printHotelType;
                $scope.printContactType = printContactType;
                $scope.showInfo = showInfo;
                
                angular.forEach(stations,function(station){
                    var stationInfo = {};
                    
                    var flightDate = $scope.flight && $scope.flight.FlightDate ? $scope.flight.FlightDate : null;
                    var contactInfo = AirportContactFactory.getAirportContacts(station);
                    stationInfo.Contacts = contactInfo ? contactInfo.Contacts : [];
                    stationInfo.ContactTypes = findDistinctContactTypes(stationInfo.Contacts)
                    
                    var hotelInfo = AirportHotelFactory.getAirportHotels(station, flightDate);
                    stationInfo.Hotels = hotelInfo ? hotelInfo.Hotels : [];
                    stationInfo.HotelTypes = findDistinctHotelTypes(stationInfo.Hotels);
                    
                    stationInfo.ActiveHotels = false;
                    stationInfo.ActiveContacts = false;
                    stationInfo.ActiveGeneralInfo= false;
                    
                    stationInfo.Name = station;
                    if(stationInfo.Hotels.length>0 || stationInfo.Contacts.length>0){
                        $scope.stationsInfo.push(stationInfo);
                    }
                    
                });
                     
                var oldViewStation = '';
                var oldViewType = '';
                    
                function showInfo(station,type){
                    
                    angular.forEach($scope.stationsInfo,function(stationInfo){
                         if(stationInfo.Name == station.Name){
                            if(type=='Hotels'){
                                stationInfo.ActiveHotels = !stationInfo.ActiveHotels;
                                stationInfo.ActiveContacts = false;
                                stationInfo.ActiveGeneralInfo=false;
                            }else if(type=='Contacts'){
                                stationInfo.ActiveContacts = !stationInfo.ActiveContacts;
                                stationInfo.ActiveHotels = false;
                                stationInfo.ActiveGeneralInfo=false;
                            }else if(type=='General'){
                                stationInfo.ActiveGeneralInfo=!stationInfo.ActiveGeneralInfo;
                                stationInfo.ActiveHotels = false;
                                stationInfo.ActiveContacts = false;
                            }
                        }else{
                            stationInfo.ActiveHotels = false;
                            stationInfo.ActiveContacts = false;
                            stationInfo.ActiveGeneralInfo=false;
                        }
                    })
                    
                }
		}
	}
}
})();
	